<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">
        {{ editing ? "Editar relación" : "Nueva relación" }}
      </h1>
    </div>
    <div class="container px-0">
      <div class="row justify-content-center">
        <div class="col-12">
          <b-card
            tag="article"
            no-body
            style="max-width: 760px"
            class="custom-card"
          >
            <b-card-header
              header-tag="section"
              class="custom-card-header d-flex align-items-center"
            >
              <h3>
                {{
                  editing
                    ? "Datos de la relación"
                    : "Datos de la nueva relación"
                }}
              </h3>
            </b-card-header>
            <b-card-body class="custom-card-body px-0 pb-0">
              <form class="custom-form" @submit.prevent="save" novalidate>
                <div class="form-section pt-0">
                  <h2 class="custom-card-subtitle mb-4">
                    Información del código principal
                  </h2>

                  <div class="row">
                    <div class="col-md-12">
                      <div
                        class="form-group"
                        :class="{ 'mb-0': !form.segmentType }"
                      >
                        <label for="type">Segmento *</label>

                        <FormSelect
                          id="type"
                          :show-error="
                            $v.form.segmentType.$error &&
                            !$v.form.segmentType.required
                          "
                          v-model="form.segmentType"
                          :items="segmentList"
                          defaultOption="Elegir segmento"
                          @change="setPusherPDVIdList()"
                        />

                        <form-error
                          message="Segmento es requerido"
                          v-if="
                            $v.form.segmentType.$error &&
                            !$v.form.segmentType.required
                          "
                        ></form-error>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group mb-0" v-if="form.segmentType && showSearchable">
                        <label for="pusher">{{
                          form.segmentType ==
                          LocalConstants.SegmentType.PUSHER.key
                            ? "Impulsador *"
                            : "Punto de Venta *"
                        }}</label>

                        <SearchableDropdown
                          :placeholder="`Elegir ${
                            form.segmentType ==
                            LocalConstants.SegmentType.PUSHER.key
                              ? 'impulsador'
                              : 'punto de Venta'
                          }`"
                          :options="pusherPDVIdList"
                          :oldValue="form.pusherPDVId"
                          @selected="form.pusherPDVId = $event"
                          :show-error="
                            $v.form.pusherPDVId.$error &&
                            !$v.form.pusherPDVId.required
                          "
                        />

                        <form-error
                          :message="`${
                            form.segmentType ==
                            LocalConstants.SegmentType.PUSHER.key
                              ? 'Impulsador'
                              : 'Punto de Venta'
                          } es requerido`"
                          v-if="
                            $v.form.pusherPDVId.$error &&
                            !$v.form.pusherPDVId.required
                          "
                        ></form-error>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-section border-0 mb-0">
                  <h2 class="custom-card-subtitle mb-4">
                    Información del código bolsa
                  </h2>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group mb-0" v-if="showSearchable">
                        <label for="code">Código de bolsa *</label>

                        <SearchableDropdown
                          placeholder="Elegir código de bolsa"
                          :options="relatedList"
                          :oldValue="form.relatedId"
                          @selected="form.relatedId = $event"
                          :show-error="
                            $v.form.relatedId.$error &&
                            !$v.form.relatedId.required
                          "
                        />

                        <form-error
                          message="Código de bolsa es requerido"
                          v-if="
                            $v.form.relatedId.$error &&
                            !$v.form.relatedId.required
                          "
                        ></form-error>
                      </div>
                    </div>
                  </div>

                  <div class="form-group-buttons text-right">
                    <a  @click="$router.push({name: 'celulares-relationships-list'})"
                        class="button button-light">
                      {{ editing ? "Volver" : "Cancelar" }}
                    </a>
                    <button class="button button-primary" type="submit">
                      Guardar
                    </button>
                  </div>
                </div>
              </form>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Alert,
  Constants,
  FormError,
  FormSelect,
  SearchableDropdown,
} from "wize-admin";

import {
  PusherService,
  RelationshipsService,
  SalesPointService,
} from "../../Core/Services";

import { required } from "vuelidate/lib/validators";

import { Constants as LocalConstants } from "@/core/utils";

export default {
  data() {
    return {
      LocalConstants,
      relatedList: [],
      identifierTypes: [
        Constants.IdentifierType.DNI,
        Constants.IdentifierType.RUC,
        Constants.IdentifierType.CE,
        Constants.IdentifierType.PASSPORT,
      ],
      pusherList: [],
      pdvList: [],
      pusherPDVIdList: [],
      segmentList: [
        LocalConstants.SegmentType.PDV,
        LocalConstants.SegmentType.PUSHER,
      ],
      form: {
        segmentType: null,
        pusherPDVId: null,
        relatedId: null,
      },
      editing: false,
      loading: true,
      showSearchable: true
    };
  },
  components: {
    FormError,
    FormSelect,
    SearchableDropdown,
  },
  validations: {
    form: {
      segmentType: { required },
      pusherPDVId: { required },
      relatedId: { required },
    },
  },
  watch: {
    "$route.params.id": function () {
      if (this.$route.params.id) this.load(this.$route.params.id);
    },
    "form.segmentType": function () {
      this.resetForm();
    },
    "form.pusherPDVId": function () {
      let key = this.form.segmentType == LocalConstants.SegmentType.PUSHER.key
        ? LocalConstants.SegmentType.PUSHER.key
        : LocalConstants.SegmentType.PDV.key;

      this.setCodeList(key);
    }
  },
  methods: {
    resetForm() {
      this.showSearchable = false

      this.form.pusherPDVId = null;
      this.form.relatedId = null;

      setTimeout(() => {
        this.showSearchable = true
      }, 100)
    },
    setPusherPDVIdList() {
      this.pusherPDVIdList =
        this.form.segmentType == LocalConstants.SegmentType.PUSHER.key
          ? [...this.pusherList]
          : [...this.pdvList];
    },
    async save() {
      this.$v.$touch();

      if (this.$v.$error) {
        this.$nextTick(() => {
          this.$smoothScroll({
            scrollTo: document.querySelector(".form-error"),
            updateHistory: false,
            offset: -50,
          });
        });
        return;
      }

      this.$store.dispatch("app/loading", true);
      const data = {
        ...this.form,
      };

      try {
        let response;
        if (!this.editing) {
          response = await RelationshipsService.save(data);
        } else {
          response = await RelationshipsService.update(
            this.$route.params.id,
            data
          );
        }

        if (response.status == "OK") {
          Alert.success("Se almacenó la información correctamente");
          if (!this.editing) {
            this.$router.push({
              name: "celulares-relationships-edit",
              params: { id: response.payload.id },
            });
            this.editing = true;
          }
        }
      } catch (ex) {
        Alert.error(ex.errors.message);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async load(id) {
      try {
        this.$store.dispatch("app/loading", true);
        const response = await RelationshipsService.get(id);
        let payload = response.payload

        this.form = {
          ...response.payload
        };

        this.setPusherPDVIdList();

        // Se agrega una espera para asignar valores restantes
        setTimeout(() => {
          this.form = {
            ...this.form,
            pusherPDVId: payload.pusher ? payload.pusher.id : payload.pdv.id,
            relatedId: payload.relatedPusher ? payload.relatedPusher.id : payload.relatedPdv.id
          }
        }, 300)

        this.editing = true;
      } catch (ex) {
        console.error(ex);
        let message = ex.errors.message;
        if (message === "No encontrado")
          message = Constants.Errors.RECORD_NOT_FOUND;
        Alert.error(message, () =>
          this.$router.push({ name: "celulares-relationships-list" })
        );
      } finally {
        this.$store.dispatch("app/loading", false);
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      }
    },
    async getPushers() {
      const response = await PusherService.listAll();

      response.payload.forEach((b) => {
        if (this.pusherList) {
          this.pusherList.push({ key: b.id, label: b.description });
        }
      });
    },
    async getPdv() {
      const response = await SalesPointService.listAll();

      response.payload.forEach((b) => {
        if (this.pdvList) {
          this.pdvList.push({ key: b.id, label: b.description });
        }
      });
    },
    setCodeList(key) {
      let pusherKey = LocalConstants.SegmentType.PUSHER.key;

      this.relatedList =
        key == pusherKey ? [...this.pusherList] : [...this.pdvList];

      let index = 0;

      index = this.relatedList.findIndex(
        (item) => item.key == this.form.pusherPDVId
      );

      // Si lo encontramos, lo eliminamos
      if (index != -1) {
        this.relatedList.splice(index, 1);
      }
    },
  },
  async created() {
    await this.getPushers();
    await this.getPdv();
    if (this.$route.params.id) await this.load(this.$route.params.id);
    else this.loading = false;
  },
};
</script>

<style lang="stylus"></style>
